const TourComponentWrapper = ({ component }) => {
  return component;
};

export default TourComponentWrapper;
